<template>
	<div>

		<div class="block block-transparent">
			<div class="block-content block-content-full p-0">
				<img src="/media/banners/gold_lifetime_membership.jpg" style="object-fit: cover;height: 100%;width: 100%;" />
			</div>
			<div v-if="ops_lifetime && ops_lifetime.has_ops_lifetime=='no'" class="block-content block-content-full text-center bg-white p-2">
				<div class="row justify-content-center">
					<div v-if="is_allowed==0" class="col-md-12 py-4 text-center">
						<div class="row text-center">
							<div class="col-6 col-md-3">
								<div class="fs-1 fw-bold text-black">{{gold_lifetime_timer.days}}</div>
								<div class="fs-sm fw-medium text-black-50">DAYS</div>
							</div>
							<div class="col-6 col-md-3">
								<div class="fs-1 fw-bold text-black">{{gold_lifetime_timer.hrs}}</div>
								<div class="fs-sm fw-medium text-black-50">HOURS</div>
							</div>
							<div class="col-6 col-md-3">
								<div class="fs-1 fw-bold text-black">{{gold_lifetime_timer.mins}}</div>
								<div class="fs-sm fw-medium text-black-50">MINUTES</div>
							</div>
							<div class="col-6 col-md-3">
								<div class="fs-1 fw-bold text-black">{{gold_lifetime_timer.secs}}</div>
								<div class="fs-sm fw-medium text-black-50">SECONDS</div>
							</div>
							<div class="col-12 mt-5">
								<h4 v-if="time_limit>0">Get this limited time offer!</h4>
								<h4 v-else>We apologize, but the limited-time offer has already expired.</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="content">
			<div v-if="ops_lifetime!==null && ops_lifetime.has_ops_lifetime=='yes'">
				<div v-if="ops_lifetime.status=='S'" class="block block-rounded">
					<div class="block-content block-content-full">
						<h3 class="text-center">Thank you for joining us as a Gold Lifetime Member.</h3>
					</div>
				</div>
				<BankAccountTemplate v-else :data="ops_lifetime" :add-alias="member.add_alias" />
			</div>

			<div v-if="((is_allowed==1 || time_limit>0) && ops_lifetime!=null && ops_lifetime.has_ops_lifetime=='no')" class="block block-rounded">
				<div class="block-content block-content-full">
					<div class="row">
						<h2>
						Truly Rich Club Lifetime Membership:<br>
						Your Path to Forever Abundance<br>
						Imagine a Life of Uninterrupted Growth, Peace, and Prosperity.
						</h2>
						<p>Dear {{capitalized(user.fname)}},</p>
						<p>
						For some time now, you've been a committed investor in your financial future and spiritual life with the <i>TrulyRichClub</i>. You've experienced the daily inspiration of GodWhispers, the wisdom of our Stock Updates, and the power of a community dedicated to true wealth.</p>
						<p>As I've connected with many of you, a common desire has emerged: "Brother Bo, what if I could just secure my membership, once and for all?"</p>
						<p>I've been listening, and I'm thrilled to present an opportunity that fulfills that very wish: <strong>The <i>TrulyRichClub</i> Lifetime Gold Membership.</strong></p>
						<h3>Why Choose a Lifetime of Abundance?</h3>
						<p>This isn't just about never renewing again. It's about securing your peace of mind and deepening your commitment to a future of financial freedom and spiritual richness.</p>
						<ul>
							<li><strong>Eliminate Annual Renewals Forever:</strong> Say goodbye to checking expiration dates and payment hassles. Enjoy pure, uninterrupted access to all <i>TrulyRichClub</i> resources, year after year, for the rest of your life.</li>
							<li><strong>Inflation-Proof Your Growth:</strong> Lock in your membership cost today. The value you receive from the Club will only grow, while your investment remains fixed, unaffected by future price adjustments.</li>
							<li><strong>Continuous Learning & Support:</strong> As the <i>TrulyRichClub</i> evolves and I add new Gold-level content, courses, and features, you'll automatically receive access without any additional cost. This is a living, breathing library of wisdom, constantly expanding for your benefit.</li>
							<li><strong>A Legacy Investment:</strong> This is a definitive step in your personal abundance journey, solidifying your foundation with our community and ensuring you always have my guidance and the unique wisdom of our mentors.</li>
						</ul>
						<h3>The Value You Receive (And The Incredible Savings!)</h3>
						<p>The <strong><i>TrulyRichClub</i> Gold Lifetime Membership</strong> is designed to provide you with a lifetime of growth, knowledge, and community. Its true value, reflecting decades of access and continuous enrichment, is <strong>PHP 120,000</strong>.</p>
						<p><strong>But because it's my birthday month, and to celebrate our forever friendship, I'm making this a truly special offer for our dedicated Gold Members.</strong></p>
						<p>For a very limited time – <strong>this week only</strong> – you can secure your <i>TrulyRichClub Gold</i> Lifetime Membership at an extraordinary special price:</p>
						<p>ONLY <strong>PHP 97,000!</strong></p>
						<p><strong>That's an immediate savings of PHP 23,000!</strong></p>
						<p>Think about it: Imagine the immense savings over 20 or 30 years of continuous growth with the <i>TrulyRichClub</i>!</p>
						<h3>But There's More! Exclusive Bonuses for Lifetime Gold Members (This Week Only!)</h3>
						<p>To make this offer even more irresistible and to truly celebrate your commitment, when you become a Lifetime Member this week, you'll also receive these priceless bonuses:</p>
						<h4>1. “Welcome 1-On-1 Breakfast with Brother Bo”</h4>
						<ul>
							<li><strong>A personal treat from me!</strong> It will be my privilege and joy to talk with you over a delicious meal. During our breakfast, you can pick my brain and consult me about anything--your finances, your business, your family, your spiritual journey, or your personal growth. This is a rare, intimate chance to gain personalized guidance directly from me.</li>
							<li><strong>You may also bring one more person</strong>—a spouse, or a parent, or a friend, to share in this special experience!</li>
							<li>(Logistics: Details on scheduling will be provided by email upon enrollment.)</li>
						</ul>
						<h4>2. Guest Pass to One (1) Special Platinum Gathering</h4>
						<ul>
							<li>Step into our inner circle! You'll receive an exclusive invitation to join one of our private Platinum Gatherings. Immerse yourself in the wisdom and energy of our most advanced Platinum members – those who have established successful businesses and are constantly strategizing to go to the next level. This is an unparalleled opportunity for high-level networking and invaluable learning.</li>
							<li>(Logistics: Platinum Gatherings are held quarterly. Details on how to select and attend your gathering will be provided via email upon enrollment.)</li>
						</ul>
						<h4>3. Free LIFETIME VIP Ticket to Our Annual Wealth Conference</h4>
						<li>Join us every year, for life! Imagine attending our premier Wealth Conference every single year, without ever buying another ticket! You'll have perpetual VIP access to the latest insights, top speakers, and cutting-edge strategies for building and growing your wealth, year after year…after year!</li>
						<li>(Logistics: Your Lifetime VIP status will be automatically registered for future conferences—provided in your TRC Dashboard.)</li>
						<p>These bonuses alone are valued far beyond the investment of the Lifetime Membership. They represent unparalleled access, personal guidance, and continuous high-level education that is simply not available anywhere else.</p>
						<h3>Don't Let This Opportunity Pass You By!</h3>
						<p>This exclusive special offer for the <i>TrulyRichClub</i> Gold Lifetime Membership, along with these priceless bonuses, is for <strong>this week only.
							The special price of PHP 97,000 and these bonuses are closing on Saturday, August 2, 2025 at 11:59 PM (Philippine Time)</strong>.
						</p>
						<p>
						After this specific deadline, the price will revert to its regular value of PHP 120,000, and these bonuses will no longer be available with the Gold Lifetime purchase.</p>
						<p>This is your very last chance to:</p>
						<ul>
							<li>Save PHP 23,000 on your lifelong membership.</li>
							<li>Eliminate annual renewals forever, freeing your mind and energy.</li>
							<li>Guarantee uninterrupted access to all of <i>TrulyRichClub's</i>blessings, now and always.</li>
							<li>Enjoy a personal Welcome Breakfast with Brother Bo!</li>
							<li>Experience one Platinum Gathering to learn from top entrepreneurs.</li>
							<li>Receive a FREE VIP ticket to our annual Wealth Conference, for life!</li>
							<li>Make a definitive statement about your unwavering commitment to financial and spiritual growth.</li>
						</ul>
						<p>Join the growing number of members who have chosen to make <i>TrulyRichClub</i> a permanent cornerstone of their abundance journey.</p>
						<h3 class="text-center">Secure Your Lifetime of Abundance Now!</h3>
						<button type="button" @click="getGoldLifetime" :disabled="renewAdvanceForm.processing" class="btn btn-primary mb-4">
							<div v-if="renewAdvanceForm.processing" class="spinner-border spinner-border-sm text-dark me-1" role="status" >
								<span class="sr-only">Please wait...</span>
							</div>YES! I want my TrulyRichClub Gold Lifetime Membership for PHP 97,000 + Bonuses! ( Click Here to Enroll )
						</button>
						<h3>Still Have Questions?</h3>
						<p>Q: What will happen to my current annual subscription? I still have several months remaining.<br>
						A: Your Lifetime Gold Membership will seamlessly replace your current annual subscription and we will deduct whatever's left from your current plan.</p>
						<p>Q: Will these bonuses be available in the future?<br>
						A: Sadly, we don’t know if we will offer this again.  The special PHP 97,000 price and these specific bonuses are exclusive to this limited-time offer, ending on Saturday, August 2, 2025 at 11:59 PM (Philippine Time).</p>
						<p>Q: What if <i>TrulyRichClub</i> adds new features in the future?<br>A: Your Gold Lifetime Membership grants you access to all current and future Gold-level benefits and content updates automatically, with no additional cost.
						</p>
						<p>May you become truly rich,<br>
						Bo Sanchez<br>
						TrulyRichClub Founder</p>

					</div>

					<!-- <div class="row mt-5">
						<div class="col-12 text-center">
							<h6 class="fw-semibold">Payment Method Bank Transfer</h6>
							<div class="mb-4 space-x-1">
								<button
									type="button"
									@click="getGoldLifetime"
									class="btn btn-alt-primary"
									:disabled="renewAdvanceForm.processing"
								>
									
									<span v-if="!renewAdvanceForm.processing">Yes I Want ...</span>
									<span v-else>
										<div class="spinner-border spinner-border-sm text-dark" role="status" >
											<span class="sr-only mr-1">Please wait...</span>
										</div>
										<span class="mx-2">Please wait...</span>
									</span>
								</button>
							</div>
						</div>

					</div> -->

				</div>
			</div>
		</div>
	</div>
</template>

<script>

	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());

	gtag('config', window.gtag_id);

	import { watch, onMounted, ref, reactive } from 'vue'
	import AuthLayout from '../../Layouts/AuthLayout'
	import { createToaster } from '@meforma/vue-toaster'
	import { useForm, usePage } from '@inertiajs/inertia-vue3'
	import Stripe from '../../Shared/Components/Stripe'

	export default{
		props:{
			user 			: Object,
			member 			: Object,
			flash 			: Object,
			errors 			: Object,
			gold_lifetime 	: Object,
			ops_lifetime 	: Object,
			is_allowed 		: Number,
		},
		layout: AuthLayout,
		components: {
			Stripe,
		},
		setup(props) {

			const capitalized = (name)=>{
		      let capitalizedFirst = name[0].toUpperCase();
		      let rest = name.slice(1);

		      return capitalizedFirst + rest;
		    }

		    const time_limit = ref(0);

			const gold_lifetime_timer = reactive({days:0,hrs:0,mins:0,secs:0});

		    const deleteCreditCardModal = ref(null);

			const renewAdvanceForm = useForm({
				subscription 	: props.member.prod_id,
				payment_method 	: 'BANK_TRANSFER',
				pmethod 		: null,
				pchannel 		: null,
				token 			: null,
				use_existing_card: props.member.has_card?true:false,
				action 	 		: 'gold_lifetime',
				rebates 		: props.member.rebates,
			});


			if(props.gold_lifetime.result=="success" && props.ops_lifetime)
			{
				if(props.ops_lifetime.has_ops_lifetime=='no')
				{	
					
					watch(time_limit,(value,old_value)=>{

						let gold_timer = null;
						let days = 0, hrs = 0, mins = 0, secs = 0;
						
						if (value>=0 && value!=old_value) {

							days 	= Math.floor(time_limit.value/60/60/24);
							hrs 	= Math.floor(time_limit.value/60/60);
							mins 	= Math.floor(time_limit.value/60);
							secs 	= value;

							secs 	= secs % 60;
							mins 	= mins % 60;
							hrs 	= hrs % 24;
							days 	= days % 24;

							gold_lifetime_timer.days 	= (days>9 ? days : "0" + days);
							gold_lifetime_timer.hrs 	= (hrs>9 ? hrs : "0" + hrs);
							gold_lifetime_timer.mins 	= (mins>9 ? mins : "0" + mins);
							gold_lifetime_timer.secs 	= (secs>9 ? secs : "0" + secs);

							clearTimeout(gold_timer);

							if (value>0) {
								gold_timer = setTimeout(function(){
								    time_limit.value--;
								},1000);
							}

						}

					})

					time_limit.value = props.gold_lifetime.data.time_limit;
				
				}
			}


			const getGoldLifetime = () => {renewAdvanceForm.post(route('member.post.upgrade'), {})}

			return{
				capitalized,
				renewAdvanceForm,
				getGoldLifetime,
				time_limit,
				gold_lifetime_timer,

			}
		}
		
	}
</script>

<style>
	ul{
		padding-left: 64px;
	}
</style>